import { BlockProps, KeepGoing, SongCard } from "./Blocks";

// Right column on your own finished cover. The separate upsell and
// suggestion blocks that used to stack here now live inside "Keep going".
export function Aside(props: BlockProps) {
  return (
    <aside className="tw-flex tw-flex-col tw-gap-3.5">
      <KeepGoing {...props} />
      <SongCard {...props} />
    </aside>
  );
}
